import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../services/global-data.service';
import { CurrencyRateService } from './pages/currency_rates/currency-rate.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/observable';
import { Message } from 'primeng/primeng';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [CurrencyRateService]

})
export class DashboardComponent implements OnInit{
	_isOpen: boolean = false;
	 msgs: Message[] = [];
	

	constructor(
		private global: GlobalDataService,
		private currencyRateService: CurrencyRateService,
		private router: Router){
	
			this.global.getMessage().subscribe(data=>{  
				this.msgs = []; 
				this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+data.text});
		  });

		  this.global.getMessageNotification().subscribe(data=>{  
			this.msgs = []; 
			this.msgs.push({severity:'success', summary:'Уведомление!', detail: data.text});
	  });

	}

	
	ngOnInit(){
		this.currencyRateService.getCurrencyRateById('4255ecaf-3ab3-4a69-93e5-5ff441242964').subscribe(response=>{this.global.currencyRate=response['data'];console.log('this.global.currencyRate');console.log(this.global.currencyRate);});
	
	}

	// canDeactivate(): Observable<boolean> | boolean {
	    // return window.confirm('Discard changes?');
	    // return false;
	// }

	clickedToggleBar():void {
  		this._isOpen=!this._isOpen;
  	}

  
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/dashboard.component.ts